export class OrderInfoItems {
    productName: string;
    id: string;
    duration: number;
    details: string;
    price: number;
    productId: number;
    purchasedActivationCode: string;
    packageDuration: number;
    defaultGateway: number;
    productInfoId: number;
    bulkCount:number;
}